import { cn } from '@/lib/utils';

export const CustomCard = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        'overflow-hidden rounded-[8px] border border-border bg-card px-6 py-4 shadow-sm',
        className,
      )}
    >
      {children}
    </div>
  );
};
